import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-3" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-danger" }
const _hoisted_6 = { class: "d-flex flex-column align-items-center mt-3" }
const _hoisted_7 = { class: "text-capitalize text-secondary" }
const _hoisted_8 = ["title"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-capitalize text-secondary" }
const _hoisted_11 = { class: "text-capitalize text-secondary" }
const _hoisted_12 = { class: "d-flex flex-row align-items-center gap-2 justify-content-center mt-3" }
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "text-secondary text-wrap" }
const _hoisted_17 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "text-secondary" }
const _hoisted_21 = { class: "row mb-3" }
const _hoisted_22 = { class: "col-sm-12" }
const _hoisted_23 = { class: "p-0 m-0" }
const _hoisted_24 = { class: "col-sm-12" }
const _hoisted_25 = { class: "me-2" }
const _hoisted_26 = {
  key: 0,
  class: "spinner-border",
  role: "status",
  style: {"zoom":"0.5"}
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_29 = { class: "col-sm-12" }
const _hoisted_30 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_PayMethodIcon = _resolveComponent("PayMethodIcon")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('labels.payout_upload_files_title'),
    modelValue: _ctx.modal !== null,
    "footer-class": "d-flex justify-content-between",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($event === false && (_ctx.modal = null)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.modal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("small", _hoisted_5, [
                    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.payout_confirmation_warning')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createElementVNode("small", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.id')) + ":", 1),
                    _cache[4] || (_cache[4] = _createTextVNode()),
                    _withDirectives((_openBlock(), _createElementBlock("span", {
                      title: _ctx.modal.deal.publicId
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.modal.deal.publicId), 1)
                    ], 8, _hoisted_8)), [
                      [
                        _directive_b_tooltip,
                        void 0,
                        void 0,
                        { hover: true }
                      ]
                    ]),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    _createVNode(_component_copy_button, {
                      value: _ctx.modal.deal.publicId
                    }, null, 8, ["value"])
                  ]),
                  (_ctx.modal.deal.actualTakerSum)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", null, [
                          _createElementVNode("small", _hoisted_10, _toDisplayString(_ctx.helper.trans('labels.sum')) + ":", 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.modal.deal.actualTakerSum)) + " ", 1),
                          _createVNode(_component_copy_button, {
                            value: _ctx.modal.deal.actualTakerSum.amount
                          }, null, 8, ["value"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.modal.deal.actualTakerSum || _ctx.modal.deal.isActualSumsChanged)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass({'text-decoration-line-through': _ctx.modal.deal.isActualSumsChanged})
                      }, [
                        _createElementVNode("small", _hoisted_11, _toDisplayString(_ctx.helper.trans('labels.sum')) + ":", 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.numberFormatter.formatMoney(_ctx.modal.deal.takerSum)) + " ", 1),
                        _createVNode(_component_copy_button, {
                          value: _ctx.modal.deal.takerSum.amount
                        }, null, 8, ["value"])
                      ], 2))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_PayMethodIcon, {
                    method: _ctx.modal.deal.paymentMethod
                  }, null, 8, ["method"]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("small", _hoisted_14, _toDisplayString(_ctx.helper.trans('payment_options.' + _ctx.modal.deal.paymentOption)) + " " + _toDisplayString(_ctx.helper.trans('pay_methods.' + _ctx.modal.deal.paymentMethod)), 1),
                    (_ctx.modal.deal.type === _ctx.Direction.PAY_OUT && _ctx.modal.deal.status === _ctx.DealStatus.NEW)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("small", _hoisted_16, _toDisplayString(_ctx.helper.trans('labels.accept_deal_to_show_req')), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("span", null, [
                            (_ctx.modal.deal.paymentOption === _ctx.PaymentOption.TO_CARD)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.modal.deal.paymentRequisites.requisites.replace(/(\d{4})/g, '$1 ').trim()), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.modal.deal.paymentRequisites.requisites), 1)),
                            _createVNode(_component_copy_button, {
                              class: "ms-1",
                              value: _ctx.modal.deal.paymentRequisites.requisites
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("small", _hoisted_20, _toDisplayString(_ctx.modal.deal.paymentRequisites.holder), 1)
                        ]))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _mergeProps({ style: {"cursor":"pointer","border":"1px dashed"} }, _ctx.dropzone.getRootProps(), { class: "payout-dropzone rounded border-secondary p-3 pt-4 pb-4 d-flex justify-content-center align-items-center" }), [
            _createElementVNode("input", _normalizeProps(_guardReactiveProps(_ctx.dropzone.getInputProps())), null, 16),
            _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.helper.trans('labels.payout_upload_files')), 1)
          ], 16)
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileAttachments, (fileAttachment) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row mb-2 ms-2",
          key: fileAttachment.id
        }, [
          _createElementVNode("div", _hoisted_24, [
            _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)),
            _cache[9] || (_cache[9] = _createTextVNode()),
            _createElementVNode("span", _hoisted_25, _toDisplayString(fileAttachment.file.name), 1),
            (fileAttachment.error === null && fileAttachment.attachment === null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, _cache[6] || (_cache[6] = [
                  _createElementVNode("span", { class: "visually-hidden" }, null, -1)
                ])))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: "#",
                  onClick: _withModifiers(($event: any) => (_ctx.removeFile(fileAttachment)), ["prevent"])
                }, _cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                ]), 8, _hoisted_27)),
            _createElementVNode("div", null, [
              (fileAttachment.error !== null)
                ? (_openBlock(), _createElementBlock("small", _hoisted_28, _toDisplayString(fileAttachment.error), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("canvas", {
              id: `pdf-canvas-${fileAttachment.id}`,
              class: "w-100"
            }, null, 8, _hoisted_30)
          ])
        ]))
      }), 128))
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal = null)),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.modal?.cancelTitle ?? _ctx.helper.trans('button.cancel')), 1),
      _createVNode(_component_LoaderWrapper, {
        ref: "loader",
        zoom: 0.5
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onOkClick())),
            class: "btn btn-outline-danger btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.modal?.okTitle ?? _ctx.helper.trans('button.ok')), 1)
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}